import http from '../clients/Axios'

export default class PurchaseInvoiceService {
  async paginate(pageNumber, pageSize = 10, sortField, sortOrder, filters) {
    pageNumber = pageNumber === undefined ? 1 : pageNumber
    const sort = sortOrder === 1 ? '-' + sortField : sortField

    let filters_param = ''

    if (filters) {
      const keys = Object.keys(filters)

      keys.forEach((el) => {
        if (filters[el].value) {
          filters_param =
            filters_param + '&filter[' + el + ']=' + filters[el].value
        }
      })
    }

    const res = await http.get(
      `/purchase/invoice/paginate?page[number]=${pageNumber}&page[size]=${pageSize}&sort=${sort}${filters_param}`
    )

    return res.data
  }

  async get(param) {
    param = param ? param : ''
    return await http.get(`/purchase/invoice${param}`)
  }

  async add(form) {
    return await http.post('/purchase/invoice', form)
  }

  async update(form) {
    return await http.post(`/purchase/invoice/${form.id}`, form)
  }

  async delete(id) {
    return await http.delete(`/purchase/invoice/${id}`)
  }

  async downloadFaktur(faktur_id) {
    return http({
      url: `/purchase/invoice/${faktur_id}/print`,
      method: 'GET',
      responseType: 'blob',
    })
  }
}
